import type {
  BlockchainNetwork,
  BlockchainNetworkQuery,
  BlockchainNetworkResponse,
} from "@/interfaces/blockchainNetwork";
import { makeRequest } from "@/utils/makeRequest";

import type {
  CreateBlockchainNetworkDto,
  UpdateBlockchainNetworkDto,
} from "@/interfaces/blockchainNetwork";

class BlockchainNetworkService {
  async getAll(
    params?: BlockchainNetworkQuery,
  ): Promise<BlockchainNetworkResponse> {
    const res = await makeRequest.get("/blockchain-network", {
      params,
    });

    return res.data;
  }

  async getOne(id: string): Promise<BlockchainNetwork> {
    const res = await makeRequest.get(`/blockchain-network/${id}`);

    return res.data.data;
  }

  async delete(id: string) {
    return makeRequest.delete(`/blockchain-network/${id}`);
  }

  async enable(id: string) {
    return makeRequest.patch(`/blockchain-network/${id}/enable`);
  }

  async disable(id: string) {
    return makeRequest.patch(`/blockchain-network/${id}/disable`);
  }

  async enableDeposits(id: string) {
    return makeRequest.patch(`/blockchain-network/${id}/deposit/enable`);
  }

  async disableDeposits(id: string) {
    return makeRequest.patch(`/blockchain-network/${id}/deposit/disable`);
  }

  async enableWithdrawals(id: string) {
    return makeRequest.patch(`/blockchain-network/${id}/withdraw/enable`);
  }

  async disableWithdrawals(id: string) {
    return makeRequest.patch(`/blockchain-network/${id}/withdraw/disable`);
  }

  async create(data: CreateBlockchainNetworkDto): Promise<BlockchainNetwork> {
    const res = await makeRequest.post("/blockchain-network", data);

    return res.data.data;
  }

  async update(
    id: string,
    data: UpdateBlockchainNetworkDto,
  ): Promise<BlockchainNetwork> {
    const res = await makeRequest.patch(`/blockchain-network/${id}`, data);

    return res.data.data;
  }
}

export default new BlockchainNetworkService();
